var map = {
	"./decidim/proposals/participatory_texts/participatory_text.md": "./vendor/ruby/3.2.0/bundler/gems/decidim-c5caa44bd1f6/decidim-proposals/app/packs/documents/decidim/proposals/participatory_texts/participatory_text.md",
	"./decidim/proposals/participatory_texts/participatory_text.odt": "./vendor/ruby/3.2.0/bundler/gems/decidim-c5caa44bd1f6/decidim-proposals/app/packs/documents/decidim/proposals/participatory_texts/participatory_text.odt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/ruby/3.2.0/bundler/gems/decidim-c5caa44bd1f6/decidim-proposals/app/packs/documents sync recursive ^\\.\\/.*$";